import React from "react";
import { Row, Image, Button } from "react-bootstrap";
import { Bounce } from "react-activity";

import logoPlano from "../../../Images/LogoWirebitTransfer-03.png";
import closeIcon from "../../../Images/close_cross.png";

import "./externalTransferConfirmation.css";
import "../../2fa/index.css";

const ExternalTransferConfirmation = ({
  traductions,
  handleSubmit,
  fromWallet,
  toAccount,
  toAlias,
  description,
  showLoad,
  onClose,
  amountW,
  cryptoSend,
  formatMoney,
  moneyFromCrypto,
  selectedCurrency,
}) => {
  const showDollarsAprox = () => {
    if (selectedCurrency === "usd") {
      return formatMoney(amountW);
    } else {
      return moneyFromCrypto;
    }
  };

  return (
    <div className="container-steps-add-wallet-general">
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Image src={logoPlano} style={{ width: "25%" }} />
        <Image
          src={closeIcon}
          onClick={onClose}
          className="external_icon_close"
        />
      </Row>
      <div className="external_ticket">
        <h3 className="external_title">
          {traductions.wallets.Index.modalTransfers.confirmation.title}
        </h3>

        <Row className="external_ticket_crypto_row">
          <Image
            src={require(`../../../CryptoIcons/${
              fromWallet.coin ?? "usd"
            }.svg`)}
            className="external_ticket_crypto_icon"
          />
          <p className="external_ticket_crypto_ammount">
            {`${cryptoSend} ${fromWallet?.coin?.toUpperCase()}`}
          </p>
          <p className="external_ticket_crypto_aprox">
            {`/${
              traductions.wallets.Index.modalTransfers.confirmation.aprox
            } ${showDollarsAprox()} USD`}
          </p>
        </Row>

        <p className="external_ticket_subtitle">
          {traductions.wallets.Index.modalTransfers.confirmation.fromWallet}:
        </p>
        <p className="external_ticket_text">{fromWallet?.alias}</p>

        <p className="external_ticket_subtitle">
          {traductions.wallets.Index.modalTransfers.confirmation.description}:
        </p>
        <p className="external_ticket_text" style={{ marginBottom: 53 }}>
          {description}
        </p>

        <p className="external_ticket_target">
          {traductions.wallets.Index.modalTransfers.confirmation.destinyTitle}
        </p>

        <p className="external_ticket_subtitle">
          {traductions.wallets.Index.modalTransfers.confirmation.accountAlias}:
        </p>
        <p className="external_ticket_text">{toAccount}</p>

        <p className="external_ticket_subtitle">
          {traductions.wallets.Index.modalTransfers.confirmation.walletAlias}:
        </p>
        <p className="external_ticket_text" style={{ marginBottom: 37 }}>
          {toAlias}
        </p>

        <Button
          onClick={handleSubmit}
          className="signup-button"
          variant="primary"
          disabled={showLoad}
          style={{ fontSize: 25 }}
        >
          {showLoad ? (
            <Bounce size={20} color={"#FFFFFF"} animating={showLoad} />
          ) : (
            traductions.wallets.Index.modalTransfers.confirmation.confirmButton
          )}
        </Button>
      </div>
    </div>
  );
};

export default ExternalTransferConfirmation;
